import { ApiGet, ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import type {
  IBeeVirtualCheckCreateRequest,
  IBeeVirtualCheckCreateResponse,
  IBeeVirtualCheckDeleteRequest,
  IBeeVirtualCheckDeleteResponse,
  IBeeVirtualCheckGetListResponse,
  IBeeVirtualCheckUpdateRequest,
  IBeeVirtualCheckUpdateResponse,
} from '@/types/VirtualCheckTypes.d.ts'
import { sanitizeBankCode } from '@/validators/BankValidator.ts'

// BIC (AbaNumber) and IBAN (AccountNumber) must reach the API free of the separators
// banks use for display; see BankValidator. Applied here so every caller is covered.
function withSanitizedBankCodes<T extends { AbaNumber?: string; AccountNumber?: string }>(
  request: T,
): T {
  return {
    ...request,
    ...(request.AbaNumber === undefined ? {} : { AbaNumber: sanitizeBankCode(request.AbaNumber) }),
    ...(request.AccountNumber === undefined
      ? {}
      : { AccountNumber: sanitizeBankCode(request.AccountNumber) }),
  }
}

export async function BeeVirtualCheckCreateConnector(
  request: IBeeVirtualCheckCreateRequest,
): Promise<IBeeVirtualCheckCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('BeeVirtualCheckCreateConnector')
  return ApiPost(url, withSanitizedBankCodes(request)) as Promise<IBeeVirtualCheckCreateResponse>
}

export async function BeeVirtualCheckUpdateConnector(
  request: IBeeVirtualCheckUpdateRequest,
): Promise<IBeeVirtualCheckUpdateResponse> {
  const url = await GetOrderEntryConnectorUrl('BeeVirtualCheckUpdateConnector')
  return ApiPost(url, withSanitizedBankCodes(request)) as Promise<IBeeVirtualCheckUpdateResponse>
}

export async function BeeVirtualCheckDeleteConnector(
  request: IBeeVirtualCheckDeleteRequest,
): Promise<IBeeVirtualCheckDeleteResponse> {
  const url = await GetOrderEntryConnectorUrl('BeeVirtualCheckDeleteConnector')
  return ApiPost(url, request) as Promise<IBeeVirtualCheckDeleteResponse>
}

export async function BeeVirtualCheckGetListConnector(
  request: Record<string, unknown> | null = null,
): Promise<IBeeVirtualCheckGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('BeeVirtualCheckGetListConnector')
  return ApiGet(url, request) as Promise<IBeeVirtualCheckGetListResponse>
}
